import { Component, Input } from '@angular/core';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

@Component({
  selector: 'wl-disclaimer[disclaimer]',
  templateUrl: './disclaimer.component.html',
  styleUrls: [
    './disclaimer.component.ed.scss',
    './disclaimer.component.essent.scss',
  ],
  standalone: true,
  imports: [RichTextWrapperComponent, CSCaptureDirective],
})
export class DisclaimerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() disclaimer!: string;
}
